import qs from "qs";
import { api } from "../config";

const getWebsite = async (locale?: string) => {
  const queryObj = {
    populate: {
      Header: {
        populate: {
          ContactButtons: "*",
          Logo: "*",
          Products: {
            populate: {
              List1: {
                populate: "*",
              },
              List2: {
                populate: "*",
              },
              List3: {
                populate: "*",
              },
              CTA: {
                populate: {
                  Media: "*",
                  Link: {
                    populate: {
                      page: {
                        fields: ["Slug"],
                      },
                    },
                  },
                },
              },
            },
          },
          Owners: {
            populate: {
              List1: {
                populate: "*",
              },
              List2: {
                populate: "*",
              },
              CTA1: {
                populate: {
                  Media: "*",
                  Link: {
                    populate: {
                      page: {
                        fields: ["Slug"],
                      },
                    },
                  },
                },
              },
              CTA2: {
                populate: {
                  Media: "*",
                  Link: {
                    populate: {
                      page: {
                        fields: ["Slug"],
                      },
                    },
                  },
                },
              },
            },
          },
          About: {
            populate: {
              List1: {
                populate: "*",
              },
              List2: {
                populate: "*",
              },
              List3: {
                populate: "*",
              },
              List4: {
                populate: "*",
              },
              CTA: {
                populate: {
                  Media: "*",
                  Link: {
                    populate: {
                      page: {
                        fields: ["Slug"],
                      },
                    },
                  },
                },
              },
            },
          },
          Contact: {
            populate: {
              List1: {
                populate: "*",
              },
              CTA: {
                populate: "*",
              },
            },
          },
        },
      },
      Footer: {
        populate: {
          Social: {
            populate: {
              page: {
                fields: ["Slug"],
              },
            },
          },
          Links: {
            populate: {
              page: {
                fields: ["Slug"],
              },
            },
          },
          ContactLinks: "*",
        },
      },
      DefaultBrands: {
        populate: {
          brands: {
            populate: "*",
          },
        },
      },
      NewsFilters: "*",
      EventsFilters: "*",
      VideosFilters: "*",
      TopLinks: {
        populate: {
          page: {
            fields: ["Slug"],
          },
        },
      },
    },
  };
  if (locale) queryObj["locale"] = locale;

  const query = qs.stringify(queryObj, {
    encodeValuesOnly: true,
  });

  try {
    const res:any = await fetch(`${api}/website?${query}`);
    res.data = await res.json();
    return res;
  } catch (err) {
    if (!locale) return;

    if (locale.split("-").length > 1) {
      return await getWebsite(locale.split("-")[0]);
    } else {
      return await getWebsite();
    }
  }
};

export {
  getWebsite
}
